module.exports = __webpack_public_path__ + "static/media/tripLoadImage.b981eb16.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/tripLoadImage.svg
// module id = 423
// module chunks = 49